(() => {
  // selektory
  const checkoutBtnSel = 'button[name="checkout"], [name="checkout"][type="submit"]';
  const guardSel = '#ts-vat-guard';
  const expressSel = '.additional-checkout-buttons, .shopify-payment-button';

  // Wyciąga VAT ID z notatki klienta. Obsługuje kilka formatów (VAT, VAT ID, NIP EU itp.)
  function extractVatFromNote(note) {
    if (!note) return null;
    const re = /(VAT[\s\-]*ID|VAT|NIP(?:\s*EU)?)\s*[:\-]?\s*([A-Z]{2}\s*[\dA-Z][\dA-Z\s\-\.]+)/i;
    const m = String(note).match(re);
    if (!m) return null;
    return m[2].replace(/\s|\.|-/g, '').toUpperCase(); // np. FR0441132396
  }

  function showGuard(msg, isError=false) {
    const g = document.querySelector(guardSel);
    if (!g) return;
    g.classList.remove('hidden');
    const el = g.querySelector('.ts-vat-msg');
    if (el) {
      el.textContent = msg || '';
      el.style.color = isError ? '#b91c1c' : 'inherit';
    }
  }

  async function revalidateVAT(vatId, countryGuess) {
    let country = (countryGuess || '').toUpperCase();
    if (!country && /^[A-Z]{2}/.test(vatId)) country = vatId.slice(0,2);
    const q = new URLSearchParams({ vat: vatId, country });
    const res = await fetch(`/apps/ts-vat-check?${q.toString()}`, { method: 'GET' });
    if (!res.ok) throw new Error('SERVICE');
    const data = await res.json();
    return !!data.valid;
  }

  async function run() {
    // tylko zalogowani z VAT w notatce
    if (!window.TS_CUSTOMER) return;
    const vatId = extractVatFromNote(window.TS_CUSTOMER.note || '');
    if (!vatId) return;

    const btn = document.querySelector(checkoutBtnSel);
    const guard = document.querySelector(guardSel);
    if (!btn || !guard) return;

    // Opcjonalnie ukryj szybkie płatności, które mogą ominąć koszyk
    const express = document.querySelector(expressSel);
    if (express) express.style.display = 'none';

    btn.classList.add('ts-disabled');
    showGuard('Sprawdzam numer VAT w VIES…');

    try {
      const ok = await revalidateVAT(vatId, window.TS_CUSTOMER.countryCode);
      if (ok) {
        showGuard('VAT zweryfikowany. Możesz kontynuować.');
        btn.classList.remove('ts-disabled');
      } else {
        showGuard('Twój numer VAT nie jest aktywny w VIES. Nie można przejść do kasy. Sprawdź numer lub skontaktuj się z nami.', true);
      }
    } catch {
      // Polityka na awarie VIES: twardo blokujemy (możesz zmienić na „miękko” jeśli wolisz)
      showGuard('Usługa weryfikacji VIES jest chwilowo niedostępna. Spróbuj ponownie za chwilę.', true);
    }
  }

  document.addEventListener('DOMContentLoaded', run);
})();
